import {
  action, makeObservable, observable, runInAction
} from 'mobx';
import i18next from 'i18next';
import {
  ApplicationService, CountryService, I18nService, UserService
} from 'services';
import { StorageHelper } from 'utils/helpers';

import { userStore } from 'stores/UserStore';
import { FRENCH_LOCALE } from 'utils/constants';

class I18nStore {
  constructor() {
    this.currentLanguage = localStorage.getItem('i18nextLng') || FRENCH_LOCALE;
    this.languageList = [];
    this.applicationListForRole = [];

    makeObservable(this, {
      currentLanguage: observable,
      languageList: observable,
      applicationListForRole: observable,
      loadLanguage: action,
      checkLanguage: action,
      loadLanguageList: action
    });
  }

  findLanguageByLocale(locale) {
    return this.languageList.find(l => l.value.toUpperCase().indexOf(locale.toUpperCase()) !== -1);
  }

  checkLanguage(lng) {
    let actualLanguage = lng;
    if (!this.findLanguageByLocale(actualLanguage)) {
      const localLanguage = localStorage.getItem('i18nextLng');
      if (localLanguage && this.findLanguageByLocale(localLanguage)) {
        // Fallback to the local saved language if the required language is not activated for this application
        actualLanguage = localLanguage;
      } else if (this.findLanguageByLocale(FRENCH_LOCALE)) {
        // Fallback to french if the local saved language is unavailable or not activated for this application
        actualLanguage = FRENCH_LOCALE;
      } else if (this.languageList.length > 0) {
        // Fallback to the first activated language for this application if french is not available
        actualLanguage = this.languageList[0].value;
      }
    }
    if (actualLanguage !== lng) {
      UserService.updateLocale(actualLanguage)
        .then(() => userStore.keycloak.updateToken(999999)
          .then(refreshed => {
            refreshed && userStore.keycloak.login();
          }));
    }
  }

  loadLanguage(lng) {
    I18nService.getLabels('DATATECNEA', lng)
      .then(bundle => this.setBundle(lng, bundle))
      .catch(() => this.setBundle(lng, JSON.parse(StorageHelper.GET('i18nextLngBundle'))));
  }

  setBundle(lng, bundle) {
    StorageHelper.SET('i18nextLngBundle', bundle);
    i18next.addResourceBundle(lng, 'translation', bundle, true, true);
    // Change the i18next language to the new one
    i18next.changeLanguage(lng)
      .then(() => runInAction(() => {
        if (localStorage.getItem('i18nextLng') !== lng) {
          // Remove the old language from the resources if it exists
          localStorage.getItem('i18nextLng') && i18next.removeResourceBundle(localStorage.getItem('i18nextLng'), 'translation');
        }
        // Set the language cache variable to the new one
        StorageHelper.SET('i18nextLng', lng);
        this.currentLanguage = lng;
      }));
  }

  loadLanguageList() {
    CountryService.getLanguageList()
      .then(languages => runInAction(() => {
        this.languageList = languages;
      }));
  }

  loadApplicationListForRole() {
    ApplicationService.getOptionsForTranslation()
      .then(resp => runInAction(() => {
        this.applicationListForRole = resp;
      }));
  }
}

export const i18nStore = new I18nStore();
